/* eslint-disable react/prop-types */
import React from 'react';
import {
  EmptyState,
  InfoGrid,
  SectionCard,
  Spin,
  Tag,
} from '../../ui';

import MerchantInfo from '../../detail/components/merchantInfo';
import LessonPlan from '../../detail/components/overview/components/lessonPlan';
import { cardPad } from './constants';
import styles from '../../detail/index.less';

/** 商家信息（基础信息 / 基础标签 / 商品定价 / 课表概览） */
export const MerchantInfoPane = (props) => {
  const {
    tenantId,
    tenantInfo = {},
    baseTags = [],
    onRefresh,
    bindAction,
    onBindActionHandled,
  } = props;

  return (
    <div>
      <SectionCard title="基础信息" bodyStyle={cardPad}>
        {/* ⚠️ 必须等 tenantInfo 到位再挂载：merchantInfo 内部用
            `useState(tenantInfo.redBookAccountId)` 这类写法把 props 灌进 state，
            且没有同步 effect。首帧拿到空对象就会永远显示 '--'。
            不改业务组件的前提下，正确解法是延迟挂载。 */}
        {tenantInfo.tenantId ? (
          <MerchantInfo
            tenantInfo={tenantInfo}
            onRefresh={onRefresh}
            bindAction={bindAction}
            onBindActionHandled={onBindActionHandled}
          />
        ) : (
          <Spin dot />
        )}
      </SectionCard>

      <SectionCard title="基础标签" subtitle="绿色标签表示 ifGreen = true">
        {baseTags.length ? (
          <div className={styles.tagList}>
            {baseTags.map((t, i) => (
              <Tag key={i} color={t.ifGreen ? 'green' : undefined}>
                {t.name}
              </Tag>
            ))}
          </div>
        ) : (
          <EmptyState compact description="暂无基础标签" />
        )}
      </SectionCard>

      <SectionCard title="商品定价">
        <InfoGrid
          column={4}
          bordered
          data={[
            { key: 'month', label: '月卡售价', value: tenantInfo.monthFee },
            { key: 'year', label: '年卡售价', value: tenantInfo.yearFee },
            {
              key: 'online',
              label: '线上指导课',
              value: tenantInfo.goodsOnlineGuideInfo,
            },
            {
              key: 'offline',
              label: '线下指导课',
              value: tenantInfo.goodsOfflineGuideInfo,
            },
            {
              key: 'custom',
              label: '包月私教',
              value: tenantInfo.goodsCustomGoodsInfo,
              span: 2,
            },
            {
              key: 'red',
              label: '小红书商品',
              value: tenantInfo.goodsRedBookInfo,
              span: 2,
            },
            {
              key: 'video',
              label: '视频号商品',
              value: tenantInfo.goodsWechatVideoInfo,
              span: 4,
            },
          ]}
        />
      </SectionCard>

      <SectionCard title="课表概览" bodyStyle={cardPad}>
        <LessonPlan tenantId={tenantId} />
      </SectionCard>
    </div>
  );
};

export default MerchantInfoPane;
